import { Datepicker } from 'vanillajs-datepicker';
import it from '../calendar/it';

export default function roomCalendar(elCalendar: string = '#field_date') { 

    const elem = document.querySelector(elCalendar) as HTMLInputElement;

    if(elem === null){

        return null;

    }

    Object.assign(Datepicker.locales, it);

    const datepicker = new Datepicker(elem, {
        language : 'it',
        minDate: new Date(),
        autohide: true,
        // datesDisabled: ['2024-10-29'],
    }); 

    // Set value
    // datepicker.setDate(get_date);

    return datepicker;

}